<template>
  <div class="pad">
    <div class="wrapper">
      <canvas class="signaturePad" ref="signaturePad"></canvas>
      <div class="sign-btns">
        <span class="btn" @click="clear" :style="{backgroundColor:'#1989fa', color: '#FFF'}">清空</span>
        <span class="btn" @click="undo" :style="{backgroundColor:'#ee0a24', color: '#FFF'}">撤销</span>
        <span class="btn" @click="savePNG" :style="{backgroundColor:'#07c160', color: '#FFF'}">确认</span>
        <span class="btn" @click="close">关闭</span>
      </div>
    </div>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad'
export default {
  data() {
    return {
      signaturePad: null,
      pngData: null
    }
  },
  created() {

  },
  mounted() {
    this.$nextTick(() => {
      const body = document.querySelector('body')
      if (body.append) {
        body.append(this.$el)
      } else {
        body.appendChild(this.$el)
      }

      this.resizeCanvas()
    })
  },
  methods: {
    resizeCanvas() {
      const canvas = this.$refs.signaturePad
      const signaturePad = new SignaturePad(canvas, {
        backgroundColor: 'rgb(255, 255, 255)',
        minWidth: 2.5,
        maxWidth: 5
      })

      const ratio = Math.max(window.devicePixelRatio || 1, 1)

      let zoom = window.scale ? ratio * window.scale : ratio

      canvas.width = canvas.offsetWidth * zoom
      canvas.height = canvas.offsetHeight * zoom
      canvas.getContext('2d').scale(ratio, ratio)

      this.signaturePad = signaturePad
    },
    clear() {
      this.signaturePad.clear()
    },
    undo() {
      const data = this.signaturePad.toData()
      if (data) {
        data.pop()
        this.signaturePad.fromData(data)
      }
    },
    savePNG() {
      const data = this.signaturePad.toDataURL('image/png')
      // this.$emit('on-save', data)
      this.rotateAPI(data)
    },
    close() {
      this.$emit('on-close')
    },
    async rotateAPI(baseImage64) {
      try {
        const { code, data } = await this.$http.post('/form-instance/rotate-image', baseImage64, { params: {
          angel: 0
        }})

        if (code === 200) {
          this.$emit('on-save', data)
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin selectnone {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout:none;
  -khtml-user-select:none;
}
.pad {
  width: 100%;
  height: 100%;
}
.wrapper {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100000;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  @include selectnone;
  .signaturePad {
    width: 100%;
    height: 100%;
    background-color: #FFF;
    @include selectnone;
  }
  .sign-btns {
    background-color: #FFF;
    border-top: 1px solid #eee;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 100001;
    box-sizing: border-box;
    height: 100px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 50px;
    padding-right: 50px;
    @include selectnone;
    .btn {
        display: inline-block;
        padding: 10px;
        width: 15%;
        background: #eee;
        border-radius: 10px;
        text-align: center;
        cursor: pointer;
        font-size: 18px;
    }
  }
}
@media screen and (orientation:landscape) {
  .sign-btns {
    display: none;
  }
}
</style>
